<template>

  <section>
  
    <div class="container card">
      
      <div class="d-flex justify-content-center">
        <h1>API documentation</h1>
      </div>

      <div class="row">

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-lead')"> 
            Lead
          </div>
        </div>

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-csi')"> 
            Csi
          </div>
        </div>

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-email')"> 
            Email
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-search')"> 
            Search
          </div>
        </div>

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-rdv')"> 
            Rdv
          </div>
        </div>

        <div class="col-md-4 ">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-rgpd')"> 
            Rgpd
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-4">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-integration')"> 
            Integration
          </div>
        </div>

        <div class="col-md-4">
          <div class="list-group-item" @click="selectedApiDocUrl('ws-webhook')"> 
            Webhook
          </div>
        </div>
        
      </div>
       
      </div>

    </section>

</template>

<script>

export default {
name: 'DashboardComponent',
components: {
    
},
data () {
  return {
    moduleConfigs: []
  }
},

mounted() {
  // load modules
  fetch("/api/modules-config")
    .then(async (response ) => {
      if (response.ok)
        this.moduleConfigs = await response.json();
    });
},

methods: {

 /* select api doc url */
  selectedApiDocUrl(moduleName){
    const module = this.moduleConfigs.find(m => m.name === moduleName);
    if (module && module.url)
      window.open(module.url, '_blank');
    else
      console.error(`URL not found for module: ${moduleName}`);
  },
  
}
}
</script>

<style scoped>
.list-group-item {
  position: relative;
  display: block;
  padding: 3rem 6rem;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125);
  width: 100%;
  font-size: large;
}
.list-group-item:hover{
  background-color: rgb(242, 241, 241);
  cursor: pointer;
}
.container {
  width: 100%;
  margin: auto;
  margin-top:10%;
  max-width: 850px;
}
.row {
  display: flex;
}

div.col-md-4 {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 33.333333%;
  padding:2px;
}
.card{
  background-color: rgb(243, 243, 243);
  padding: 20px;
}
</style>

